/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

/**
 * library imports.
 */
import { OwlOptions } from 'ngx-owl-carousel-o';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { GetService } from '../../dataservices/get.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';

/**
 * Common Suggestion Component
 */
@Component({
  selector: 'app-common-suggestion',
  templateUrl: './common-suggestion.component.html',
  styleUrls: ['./common-suggestion.component.scss'],
})
export class CommonSuggestionComponent implements OnInit, OnDestroy {
  @Input() callingfrom;
  @Input() suggestionObj;
  @Input() suggcallingfrom;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public detailsuggList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public sugg_heading: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public drugsuggList: any;
  /**
   * Subscription for suggestionList to unsubscribe.
   */
  public suggestionListSubs: Subscription;

  /**
   * Owl carousel settings
   */
  public customOptionsnew: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: [
      '<i class="prev-slider position-absolute"></i>',
      '<i class="next-slider position-absolute"></i>',
    ],
    responsive: {
      0: {
        items: 2,
      },
      400: {
        items: 2,
      },
      600: {
        items: 2,
      },
      940: {
        items: 2,
      },
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
  };

  /**
   * used to create object of a class
   */
  constructor(
    public fcs: FunCollectionService,
    private getClinicalCaseSer: GetService,
    private jwtSer: JwtDecodeService
  ) { }

  /**
   * call suggestionList
   */
  ngOnInit(): void {
    this.suggestionList();
  }

  /**
   * call suggestion list Api   total_connection_request
   */
  suggestionList(): void {

    this.suggestionListSubs = this.getClinicalCaseSer
      .getSuggestionList(
        this.suggestionObj.offset,
        this.suggestionObj.product_type,
        this.suggestionObj.product_type_id,
        this.suggestionObj.section
      )
      .subscribe((resData) => {
        this.jwtSer.decodeData(resData).then((data) => {
          if (data.status === 1) {
            if (data.code === 2000) {
              this.sugg_heading = data.data.suggestion_list.text_highlight;
              this.detailsuggList = data.data.suggestion_list.products;
              this.drugsuggList = data.data.drug_list;
            } else {
              this.sugg_heading = null;
            }
          }// condition closed
        });
      }, error => {
        this.fcs.errorHandeler(error);
      });
  }
  /**
   * suggestionList API is unsubscribed
   */
  ngOnDestroy(): void {
    if (this.suggestionListSubs) {
      this.suggestionListSubs.unsubscribe();
    }
  }
}
